import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const userAvatar: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  borderRadius: "50px",
}

export const avatarUploadBtn: SxProps<Theme> = {
  position: "absolute",
  padding: "0",
  right: 0,
  bottom: 0,
  zIndex: 50,
  width: "40px",
  minWidth: "40px",
  textAlign: "center",
  height: "40px",
  borderRadius: "50%",
  backgroundColor: "var(--Schemes-Primary)",
  color: "var(--Schemes-Surface)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "14px",
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "var(--Schemes-Primary)",
    transform: "scale(1.05)",
    transition: "all 0.3s ease",
  },
  "@media (max-width: 500px)": {
    width: "36px",
    height: "36px",
    minWidth: "36px",
  },
}

export const profileViewButton: SxProps<Theme> = {
  display: "inline-flex",
  fontFamily: "Roboto, sans-serif",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  textAlign: "center",
  color: "var(--Schemes-Primary)",
  padding: "10px 16px",
  gap: "8px",
  borderRadius: "100px",
  minHeight: "40px",
  maxWidth: "100%",
  minWidth: "100px",
  alignSelf: "center",
  ":hover": {
    backgroundColor: "var(--Schemes-Surface-Container-Highest)",
  },
}
